import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { FormControl, FormGroup } from '@angular/forms';
import { IHouseholdInteractionDialog } from 'app/models/household/household-interaction-dialog';
import { IHouseholdInteraction } from 'app/models/household/household-interaction';
import { HouseholdService } from 'app/services/household-service';
import { AuthService } from '@shared/auth/auth.service';

/*
 * Edit Household Dialog
 */
@Component({
  selector: 'dialog-household-interection-edit',
  templateUrl: 'household-interection-edit-dialog.html',
  styleUrls: ['./household-interection-edit-dialog.scss']
})
export class DialogEditHouseholdInteractionComponent implements OnInit {
  @Input('householdId')
  householdId: number = 0;
  loading: boolean = false;
  processing: boolean = false;
  interactionDialog: IHouseholdInteractionDialog = null;

  contactTypes: string[] = ['Phone', 'Email', 'In Person', 'Other']

  interactionForm = new FormGroup({
    id: new FormControl(0),
    comment: new FormControl(''),
    result: new FormControl(''),
    type: new FormControl(''),
    approvedByStaff: new FormControl({ 
      value: this.authService.isReadOnly() ? false : true, 
      disabled: this.authService.isReadOnly() ? true : false})
  });

  interaction: IHouseholdInteraction = {
    id: 0,
    comment: '',
    createDate: '',
    createdby: '',
    householdId: 0,
    lastUpdated: '',
    lastUpdatedBy: '',
    result: '',
    type: '',
    approvedByStaff: false,
    isUserReadOnly: false
  };

  constructor(public oregonWellDataService: OregonWellDataService,
    public householdService: HouseholdService, public authService: AuthService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: IHouseholdInteractionDialog,
    private dialogRef: MatDialogRef<DialogEditHouseholdInteractionComponent>) {
      this.interactionDialog = this.data;
  }

  ngOnInit(): void {
    if(this.interactionDialog.householdId <= 0) {
      this.toastr.error('Invalid Household Id');
      this.dialogRef.close();
    }  
    else if(this.interactionDialog.id > 0) {
      this.load();
    }
  }

  load() {
    this.processing = true;
    this.householdService.getHouseholdInteraction(this.interactionDialog.id).subscribe(
      result => {
        this.interaction = result;
        this.setFormValues();
        this.processing = false;
        
      },
      error => {
        this.toastr.error("Unable to load Household Interaction");
        this.processing = false;
        this.dialogRef.close();
      }
    );
  }

  save() {
    this.processing = true;
    this.setInteractionFromForm();

    this.interaction.isUserReadOnly = this.authService.isReadOnly();
    
    this.householdService.saveHouseholdInteraction(this.interaction).subscribe(
      result => {
        this.toastr.success("Household Interaction Saved");
        this.processing = false;
        this.dialogRef.close();
      },
      error => {
        this.toastr.error("Unable to save Household Interaction")
        this.processing = false;
      }
    );
  }

  setInteractionFromForm() {
    this.interaction.householdId = this.interactionDialog.householdId;
    this.interaction.result = this.interactionForm.get('result').value;
    this.interaction.type = this.interactionForm.get('type').value;
    this.interaction.comment = this.interactionForm.get('comment').value;
    this.interaction.approvedByStaff = this.interactionForm.get('approvedByStaff').value;
  }

  setFormValues() {
    this.interactionForm.get('result').setValue(this.interaction.result);
    this.interactionForm.get('comment').setValue(this.interaction.comment);
    this.interactionForm.get('type').setValue(this.interaction.type);
    this.interactionForm.get('approvedByStaff').setValue(this.interaction.approvedByStaff);
  }
}